export default "__VITE_ASSET__DEFVivAE__"